import Usuario from "model/administracao/cadastro/Usuario";
import { BaseModel } from "model/BaseModel";

export default class CategoriaDocumento implements BaseModel {
    id: number;
    codigo: string | null="";
    nome: string;
    prefixo: string;
    temAprovacao: boolean;
    responsavelDistribuicao: Usuario | null;
    revisorPadrao: Usuario | null;
    aprovadorPadrao: Usuario | null;

    constructor(
        id: number = 0,
        nome: string = "",
        prefixo: string = "",
        temAprovacao: boolean = true,
        responsavelDistribuicao: Usuario | null = null,
        revisorPadrao: Usuario | null = null,
        aprovadorPadrao: Usuario | null = null
    ) {
        this.id = id;
        this.nome = nome;
        this.prefixo = prefixo;
        this.temAprovacao = temAprovacao;
        this.responsavelDistribuicao = responsavelDistribuicao;
        this.revisorPadrao = revisorPadrao;
        this.aprovadorPadrao = aprovadorPadrao;
    }
}